import React, { useState } from "react";
import Image from "../../../components/AppImage";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const BlogPostCard = ({ post, onReadMore, featured = false }) => {
  const [isLiked, setIsLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(post?.likes || 0);

  const handleLike = () => {
    setIsLiked(!isLiked);
    setLikeCount(isLiked ? likeCount - 1 : likeCount + 1);
  };
  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <article
      className={`
        bg-card rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-[1.02]
        ${featured ? "md:grid md:grid-cols-2" : ""}
      `}
    >
      {/* ================= IMAGE ================= */}
      <div className="relative overflow-hidden bg-muted">
        <div
          className={`
            w-full
            ${featured ? "h-56 md:h-64" : "h-44 md:h-48"}
          `}
        >
        <img
          src={post.coverImage}
          className="w-full h-full object-cover"
          alt={post.title}
        />
        </div>

        {featured && (
          <div className="absolute top-3 left-3 bg-accent text-accent-foreground px-3 py-1 rounded-md text-xs font-semibold">
            Featured
          </div>
        )}
      </div>

      {/* ================= CONTENT ================= */}
      <div className="p-4 md:p-6 flex flex-col justify-between">
        <div>
          {/* META */}
          <div className="flex items-center gap-3 text-xs text-muted-foreground mb-2">
            <span>{formatDate(post?.publishedAt)}</span>
            {post?.readTime && (
              <>
                <span>•</span>
                <span>{post.readTime} min read</span>
              </>
            )}
          </div>

          {/* TITLE */}
          <h3
            onClick={() => onReadMore(post?.slug)}
            className={`
              font-heading font-bold text-foreground cursor-pointer hover:underline
              ${featured ? "text-xl md:text-2xl" : "text-lg"}
            `}
          >
            {post?.title}
          </h3>

          {/* EXCERPT */}
          <p className="text-muted-foreground text-sm mt-2 line-clamp-3">
            {post?.excerpt}
          </p>
        </div>

        {/* FOOTER */}
        <div className="flex items-center justify-between pt-4 mt-4 border-t border-border">
          <div className="flex items-center gap-4 text-xs text-muted-foreground">
            <div className="flex items-center gap-1">
              <Icon name="Eye" size={14} />
              {post?.views || 0}
            </div>
            <div className="flex items-center gap-1 cursor-pointer hover:scale-110 transition-transform"
                 onClick={handleLike}>
              <Icon 
                name="Heart" 
                size={14} 
                className={isLiked ? "text-red-500 fill-red-500" : "text-gray-400"}
              />
              {likeCount}
            </div>
          </div>

          <Button
            variant="ghost"
            size="sm"
            onClick={() => onReadMore(post?.slug)}
            iconName="ArrowRight"
            iconPosition="right"
          >
            Read
          </Button>
        </div>
      </div>
    </article>
  );
};

export default BlogPostCard;
